"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requiredParamsValidator = exports.isValid = void 0;
var models_1 = require("../../models");
var requiredParams = [models_1.AuthSuiteRequestDataType.CLIENT_ID, models_1.AuthSuiteRequestDataType.COUNTRY_CODE];
var isValid = function (authSuiteRequestData) {
    return requiredParams.every(function (requiredParam) { return authSuiteRequestData[requiredParam]; });
};
exports.isValid = isValid;
exports.requiredParamsValidator = {
    isValid: exports.isValid,
};
